module.exports = __webpack_public_path__ + "img/logo_v1_whitebg-2.6e49f8d4.jpeg";